//Criteria.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as SalesSearch from "./SalesSearch";
import * as SalesSearchSettings from "./SalesSearchSettings";
import * as Util from "../Util/Util";

import { Icon, IconButton } from "@mui/material";
import { blueGrey } from '@mui/material/colors';

import React from "react";

let ss: SalesSearchSettings.iSS; //Settings.

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   Util.logMsg("Top of Criteria.Render");

   //Initialize only one time.
   if (typeof ss === "undefined") {
      ss = SalesSearchSettings.ss; //Get settings.
   }

   //Wire up component for each time render is called, but not on refresh.
   const [initComponent, setState] = React.useState(() => {
   });

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Subject value changed.
   function subjectValueChanged(criteriaKey: string, event: React.ChangeEvent<HTMLInputElement>) {
      const criteria: SalesSearchSettings.iCriteria = ss[criteriaKey];

      criteria.subjectValue = 0;
      if (event.currentTarget.value !== "") {
         criteria.subjectValue = event.currentTarget.valueAsNumber;
      }
   }

   //Minimum criteria value changed.
   function minValueChanged(criteriaKey: string, event: React.ChangeEvent<HTMLInputElement>) {
      const criteria: SalesSearchSettings.iCriteria = ss[criteriaKey];

      criteria.minValue = 0;
      if (event.currentTarget.value !== "") {
         criteria.minValue = event.currentTarget.valueAsNumber;
      }
   }

   //Maximum criteria value changed.
   function maxValueChanged(criteriaKey: string, event: React.ChangeEvent<HTMLInputElement>) {
      const criteria: SalesSearchSettings.iCriteria = ss[criteriaKey];

      criteria.maxValue = 0;
      if (event.currentTarget.value !== "") {
         criteria.maxValue = event.currentTarget.valueAsNumber;
      }
   }

   //Clear criteria.
   function clearCriteria(criteriaKey: string) {
      const criteria: SalesSearchSettings.iCriteria = ss[criteriaKey];
      criteria.minValue = 0;
      criteria.maxValue = 0;
      refresh();
   }

   //Get criteria rows.
   function getCriteriaRows() {
      const jsx: JSX.Element[] = [];

      const styles2: Default.iStyles = {
         bodyCellValue: { padding: 1, paddingRight: 2 },
         input: { height: 22, width: 68, border: "1px solid silver", borderRadius: 5, textAlign: 'right' },
         clearButton: { border: '1px solid silver', marginLeft: -2 },
      };

      const propTypeSpec: SalesSearchSettings.iPropType = SalesSearchSettings.getPropTypeSpec(SalesSearch.propertyType);
      const omitImprove: SalesSearchSettings.iOmitImproveTypeCriteria = SalesSearchSettings.getOmitImproveTypeSpec(SalesSearch.improvementType);

      for (const criteriaKey of propTypeSpec.criteriaKeys) {
         if (omitImprove && omitImprove.criteriaKeys.Contains(criteriaKey)) {
            continue;
         }

         const criteria: SalesSearchSettings.iCriteria = ss[criteriaKey];
         if (!criteria) {
            Util.errMsg("Criteria setting not found for key: " + criteriaKey);
            continue;
         }

         if (criteria && (typeof criteria.weighting !== "undefined")) {
            let subjectValue: string = "";
            if (criteria.subjectValue) {
               subjectValue = criteria.subjectValue.toString();

               if (criteria.alias.Contains("Sale Price")) {
                  subjectValue = Util.formatTextValue(subjectValue, "Money");
               }
            }

            let minValue: string = "";
            if (criteria.minValue) {
               minValue = criteria.minValue.toString();
            }

            let maxValue: string = "";
            if (criteria.maxValue) {
               maxValue = criteria.maxValue.toString();
            }

            let dataType: string = "number";
            let subjectDisabled: boolean = false;
            if (criteria.alias.Contains("Sale Price")) {
               subjectDisabled = true;
               dataType = "text";
            }

            jsx.push(
               <tr key={Util.uid()}>
                  <td>{criteria.alias}</td>

                  <td style={styles2.bodyCellValue}>
                     <input style={styles2.input} id={"subject-id-" + criteriaKey} type={dataType} defaultValue={subjectValue} onChange={(event) => subjectValueChanged(criteriaKey, event)} disabled={subjectDisabled} placeholder="Value" aria-label="Value" />
                  </td>
                  <td style={styles2.bodyCellValue}>
                     <input style={styles2.input} id={"min-id-" + criteriaKey} type="number" defaultValue={minValue} onChange={(event) => minValueChanged(criteriaKey, event)} placeholder="Min" aria-label="Min value" />
                  </td>
                  <td style={styles2.bodyCellValue}>
                     <input style={styles2.input} id={"max-id-" + criteriaKey} type="number" defaultValue={maxValue} onChange={(event) => maxValueChanged(criteriaKey, event)} placeholder="Max" aria-label="Max value" />
                  </td>

                  <td>
                     <IconButton style={styles2.clearButton} color="primary" size="small" onClick={() => clearCriteria(criteriaKey)} title="Clear" aria-label="Clear">
                        <Icon fontSize="small">clear</Icon>
                     </IconButton>
                  </td>
               </tr>,
            );
         }
      }
      return jsx;
   }

   //Set render values.
   const styles: Default.iStyles = {
      criteriaTable: { borderCollapse: 'collapse', borderSpacing: 0, margin: 0, padding: 0 },
      headingCell: { border: '1px solid gainsboro', borderTop: '1px solid #e6e6e6', backgroundColor: blueGrey[50], fontWeight: 500, textAlign: 'center', padding: 2, fontSize: '0.9rem' },
      clearButton: { border: '1px solid silver' },
   };

   return (
      <table style={styles.criteriaTable}>
         <thead>
            <tr tabIndex={-1}>
               <th>Filters</th>
               <th style={styles.headingCell}>Subject</th>
               <th style={styles.headingCell}>Min</th>
               <th style={styles.headingCell}>Max</th>
               <th>.</th>
            </tr>
         </thead>

         <tbody>
            {getCriteriaRows()}
         </tbody>
      </table>
   ); //end return.

} //end function.
